import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../../api/mockData';
import './index.css';

const PostCard = ({ post, featured = false }) => {
  const [isLiked, setIsLiked] = useState(false);
  const [isBookmarked, setIsBookmarked] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  // 处理点赞
  const handleLike = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    if (!isLiked) {
      const response = await api.likePost(post.id);
      if (response.success) {
        setIsLiked(true);
        post.likes = response.data.likes;
      }
    }
  };

  // 处理收藏
  const handleBookmark = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsBookmarked(!isBookmarked);
  };

  // 获取猫咪表情根据文章分类
  const getCatEmoji = (category) => {
    const emojiMap = {
      '日常趣事': '😺',
      '养护知识': '📚',
      '行为解读': '🔍',
      '饮食健康': '🍲',
      '新手指南': '🐱'
    };
    return emojiMap[category] || '🐱';
  };

  // 格式化时间
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日`;
  };

  // 获取卡片颜色主题
  const getCardTheme = (category) => {
    const themes = {
      '日常趣事': { bg: '#FFE4E1', text: '#FF6B9D' },
      '养护知识': { bg: '#E6F7FF', text: '#1890FF' },
      '行为解读': { bg: '#F0F7FF', text: '#597EF7' },
      '饮食健康': { bg: '#F6FFED', text: '#52C41A' },
      '新手指南': { bg: '#FFF7E6', text: '#FA8C16' }
    };
    return themes[category] || { bg: '#F5F5F5', text: '#666' };
  };

  const theme = getCardTheme(post.category);
  const catEmoji = getCatEmoji(post.category);

  return (
    <Link 
      to={`/post/${post.id}`} 
      className={`post-card ${featured ? 'featured' : ''}`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{ 
        '--card-bg': theme.bg,
        '--card-accent': theme.text 
      }}
    >
      {/* 装饰性猫咪耳朵 */}
      <div className="card-cat-ears">
        <div className="cat-ear left-ear"></div>
        <div className="cat-ear right-ear"></div>
      </div>

      {/* 装饰性猫咪尾巴 */}
      <div className={`card-cat-tail ${isHovered ? 'wagging' : ''}`}></div>

      {/* 文章封面图 */}
      <div className="post-cover">
        <img 
          src={post.coverImage} 
          alt={post.title}
          className="cover-image"
          loading="eager"
        />
        <div className="cover-overlay">
          <div className="category-badge" style={{ backgroundColor: theme.text }}>
            {catEmoji} {post.category}
          </div>
          {post.featured && (
            <div className="featured-badge">
              <span className="star">⭐</span>
              <span>精选文章</span>
            </div>
          )}
        </div>
      </div>

      {/* 文章内容 */}
      <div className="post-content">
        <div className="post-header">
          <h3 className="post-title">{post.title}</h3>
          <p className="post-excerpt">{post.excerpt}</p>
        </div>

        <div className="post-meta">
          <div className="meta-item author">
            <img 
              src={post.author.avatar} 
              alt={post.author.name}
              className="author-avatar"
            />
            <span className="author-name">{post.author.name}</span>
          </div>
          <div className="meta-item date">
            <span className="meta-icon">📅</span>
            <span>{formatDate(post.publishDate)}</span>
          </div>
        </div>

        <div className="post-stats">
          <div className="stat-item">
            <span className="stat-icon">👀</span>
            <span className="stat-value">{post.views}</span>
          </div>
          <div className="stat-item">
            <span className="stat-icon">⏱️</span>
            <span className="stat-value">{post.readTime}</span>
          </div>
          <div className="stat-item">
            <button 
              className={`like-button ${isLiked ? 'liked' : ''}`}
              onClick={handleLike}
            >
              <span className="heart-icon">{isLiked ? '❤️' : '🤍'}</span>
              <span className="like-count">{post.likes + (isLiked ? 1 : 0)}</span>
            </button>
          </div>
          <div className="stat-item">
            <span className="stat-icon">💬</span>
            <span className="stat-value">{post.comments}</span>
          </div>
        </div>

        {/* 标签 */}
        <div className="post-tags">
          {post.tags.map((tag, index) => (
            <span 
              key={index} 
              className="tag"
              style={{ 
                backgroundColor: `${theme.text}20`,
                color: theme.text
              }}
            >
              #{tag}
            </span>
          ))}
        </div>

        {/* 底部操作栏 */}
        <div className="post-footer">
          <button 
            className={`bookmark-button ${isBookmarked ? 'bookmarked' : ''}`}
            onClick={handleBookmark}
          >
            {isBookmarked ? '🔖' : '📑'}
          </button>
          <div className="read-more">
            <span>阅读全文</span>
            <div className="paw-trail">
              <span className="paw">🐾</span>
              <span className="paw">🐾</span>
              <span className="paw">🐾</span>
            </div>
          </div>
        </div>
      </div>

      {/* 悬停时的猫咪装饰 */}
      {isHovered && (
        <div className="hover-cat-decoration">
          <div className="floating-cat">🐈</div>
        </div>
      )}
    </Link>
  );
};

export default PostCard;